import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

import { UserAuthProvider } from './context/UserAuthProvider';
import { GlobalStatusProvider } from './context/GlobalStatusProvider';

import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <GlobalStatusProvider>
      <UserAuthProvider>
        <Router>
          <App />
        </Router>
      </UserAuthProvider>
    </GlobalStatusProvider>
  // </React.StrictMode>
);